import React from 'react';
import Notes from '@mui/icons-material/Notes';
import config from './config';

export default {
  topNav: [
    {
      name: 'Blog',
      url: '/blog/',
      icon: <Notes />,
    },
    // {
    //   name: 'Docs',
    //   url: 'https://api.nualang.fathominnovation.com',
    //   icon: <GroupWork />
    // }
    // {
    //   divider: true
    // },
  ],
  website: {
    topNav: [
      {
        name: 'resources',
        links: [
          {
            name: 'footer_about_educators',
            url: '/educators',
          },
          {
            name: 'publishers',
            url: '/publishers',
          },
          {
            name: 'features',
            url: '/features',
          },
          {
            name: 'footer_help_guides',
            url: '/guides',
          },
          {
            name: 'footer_help_faqs',
            url: '/faq',
          },
          {
            name: 'footer_about_blog',
            url: '/blog',
          },
          {
            name: 'footer_about_team',
            url: '/team',
          },
          {
            name: 'footer_about_pricing',
            url: '/pricing',
          },
          {
            name: 'interactive_demo',
            url: '/demo',
          },
          {
            name: 'free_trial',
            url: `${config.APP_URL}/welcome?plan=teacher_pro&freeTrial=true&action=signUp`,
          },
        ],
      },
      {
        name: 'contact',
        url: '/contact',
      },
    ],
  },
};
